import axios from "axios"
import { BASE_URL } from "../api/axios"
import { getToken } from "../assets/js/features/token/TokenEncryption"

const useRefreshToken = () => {
  const refresh = async () => {
    const token = getToken()
    const response = await axios.get(
      `${BASE_URL}/auth/refresh_token`,
      {
        headers: {
          "Content-Type": "application/json",
          isRefreshToken: "true",
          Authorization: `Bearer ${token}`
        }
      }
    )
    return response.data.accessToken
  }
  return refresh
}

export default useRefreshToken
